<template>
  <div class="container">
    <div class="item">
      <NotFound />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NotFound from "@/components/core/NotFound.vue";

export default {
  name: "NotFoundView",
  components: {
    NotFound,
  },
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
}

.item {
  width: 50%;
  height: 50%;
  /* border: 1px dashed greenyellow; */
}
</style>
